


















import { trackEvent } from './../../../../utils/index';
import { defineComponent, computed, toRefs } from '@vue/composition-api';

const name = 'ttam-product-details-select-header-select';
export default defineComponent({
  props: {
    isAllSelected: {
      type: Boolean,
      default: false,
    },
    isIndeterminate: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { isAllSelected, isIndeterminate } = toRefs(props);
    const value = computed({
      get: () => isAllSelected.value,
      set: val => {
        emit('change');

        if (!isAllSelected.value) {
          trackEvent('module_ad_group_shop_product_select_all');
        }
      },
    });
    return {
      value,
      name,
    };
  },
});
